import * as React from 'react';

import { IActionContext } from '@msdyn365-commerce/core';
import { ProductPrice, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { PriceDropSubscriptionModal } from './Klaviyo/price-drop-subscription-modal';
import { UncontrolledTooltip } from '@msdyn365-commerce-modules/utilities';

import classnames from 'classnames';

const KlaviyoPriceDropSubscription = ({
    context,
    product,
    productPrice
}: {
    context: IActionContext;
    product?: SimpleProduct;
    productPrice?: ProductPrice;
}) => {
    const btnRef = React.createRef<HTMLButtonElement>();
    const [modalOpen, setModalOpen] = React.useState(false);

    if (!product || !productPrice) {
        return null;
    }

    const label = 'Get Sale Alert';
    return (
        <div className={classnames('hei-klaviyo-subscription')}>
            <button
                type='button'
                onClick={() => {
                    setModalOpen(true);
                }}
                ref={btnRef}
            >
                <span>{label}</span>
            </button>
            <UncontrolledTooltip trigger='hover focus' target={btnRef}>
                {label}
            </UncontrolledTooltip>
            <PriceDropSubscriptionModal
                context={context}
                product={product}
                className='hei-back-in-stock-modal'
                modalOpen={modalOpen}
                setModalOpen={v => setModalOpen(v)}
                productPrice={productPrice}
            />
        </div>
    );
};

export { KlaviyoPriceDropSubscription };
